import React, { useState, useCallback, useEffect } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import AppHeader from "../../components/AppHeader";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import { ethers } from "ethers";
import { useDispatch } from "react-redux";
import * as walletAction from "../../store/actions/wallet";
import { useSelector } from "react-redux";
import NftMintCard from "../../components/NftMintCard";


const useStyles = makeStyles(() => ({
    root: {
      background: "#fff",
      height: "90vh",
      paddingTop: "64px",
    },
    utilities: {
      marginTop: "3rem",
    },
    errorContainer: {
      marginTop: "3rem",
    },
  }));
  
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const MintNft = () => {
    const { root, utilities, errorContainer } = useStyles();
    const [open, setOpen] = useState(false);
    const [count, setCount] = useState(0);
    const [errorOpen, setErrorOpen] = useState(false);
    const [isCancelled, setIsCancelled] = React.useState(false);
  
    const dispatch = useDispatch();
    const wallet = useSelector((state) => state.wallet);
    const handleClick = () => {
      setOpen(true);
    };
  
   
    const handleMetamaskNotConnectedClick = () => {
      setErrorOpen(true);
    };
  
    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpen(false);
      setErrorOpen(false);
    };
  
    const getAccountFromMetamask = useCallback(async () => {
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const account = await signer.getAddress();
        dispatch(walletAction.fetchWallet(provider, signer, account));
        handleClick();
      } catch (err) {
        handleMetamaskNotConnectedClick();
      }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
    useEffect(() => {
      if (window && window.ethereum) {
        window.ethereum.on("accountsChanged", () => {
          setIsCancelled(false);
          setCount(count + 1);
        });
      }
      if (!isCancelled) {
        getAccountFromMetamask();
      }
      return () => {
        setIsCancelled(true);
      };
    }, [count, getAccountFromMetamask]); // eslint-disable-line react-hooks/exhaustive-deps
    try {
        new ethers.providers.Web3Provider(window.ethereum);
        return (
          <div className={root}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <AppHeader ethAccount={wallet.account} />
              </Grid>
              <Grid
                justifyContent="center"
                alignItems="center"
                container
                style={{ marginTop: "5rem" }}
                item
                xs={12}
              >
                <br />
                <br />
                  <NftMintCard />
                <br />
                <br />
                  <p
                    style={{
                      position: "absolute",
                      bottom: "5%",
                      left: "50%",
                      fontWeight: "bold",
                    }}
                  >
                    Mint NFT
                  </p>
              </Grid>
            </Grid>
            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="success">
                Metamask connected
              </Alert>
            </Snackbar>
          </div>
        );
      } catch (err) {
        return (
          <div className={root}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <AppHeader ethAccount={wallet.account} />
              </Grid>
              <Grid item container>
                <Grid
                  item
                  container
                  xs={12}
                  direction="row"
                  justifyContent="center"
                  alignItems="flex-end"
                  className={errorContainer}
                >
                  <Typography variant="h6">
                    Please connect Metamask to your browser to use this application
                  </Typography>
                  <Snackbar
                    open={errorOpen}
                    autoHideDuration={2000}
                    onClose={handleClose}
                  >
                    <Alert onClose={handleClose} severity="error">
                      MetamMask not detected!!
                    </Alert>
                  </Snackbar>
                </Grid>
                <Grid
                  container
                  item
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <div className={utilities}>
                    <p>
                      Get Metamask at {"  "}
                      <a
                        href="https://metamask.io/download.html"
                        rel="noreferrer"
                        target="_blank"
                      >
                        here
                      </a>
                    </p>
                    <p>
                      ETH for Rinkeby {"  "}
                      <a
                        href="https://faucet.rinkeby.io/"
                        rel="noreferrer"
                        target="_blank"
                      >
                        here
                      </a>
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      }
    };

export default MintNft;
